var App = App || {};

// CommunityInvolvement module with smooth looping autoplay controls
App.CommunityInvolvement = (function () {
    'use strict';

    function init() {
        const components = document.querySelectorAll(".block-community-involvement");
        components.forEach(function (component) {
            const carousel = component.querySelector(".block-community-involvement__carousel.splide");
            if (carousel && carousel.dataset.communityInvolvementInitialized !== 'true') {
                carousel.dataset.communityInvolvementInitialized = 'true';
                initCarousel(carousel);
            }
        });
    }

    function resumeSplideAutoplay(splide, hasAutoScroll) {
        if (!splide) return;

        if (hasAutoScroll && splide.Components && splide.Components.AutoScroll && typeof splide.Components.AutoScroll.play === 'function') {
            splide.Components.AutoScroll.play();
            return;
        }

        if (splide.Components && splide.Components.Autoplay && typeof splide.Components.Autoplay.play === 'function') {
            splide.Components.Autoplay.play();
        }
    }

    function buildCarouselOptions(useAutoScroll) {
        const options = {
            type: 'loop',
            arrows: false,
            pagination: false,
            autoWidth: true,
            focus: 0,
            trimSpace: false,
            gap: '2rem',
            autoplay: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            resetProgress: false,
            drag: false,
            snap: false,
            // AutoScroll writes these to the toggle button's aria-label as it plays/pauses
            i18n: {
                startScroll: 'Play',
                pauseScroll: 'Pause',
            },
            autoScroll: {
                speed: .5,
                autoStart: true,
                useToggleButton: true,
                pauseOnHover: false,
                pauseOnFocus: false,
            },
        };

        if (!useAutoScroll) {
            options.perMove = 1;
            options.speed = 900;
            options.easing = 'ease';
            options.waitForTransition = true;
        }

        return options;
    }

    function initCarousel(carousel) {
        if (typeof Splide === 'undefined') {
            console.warn('CommunityInvolvement: Splide library not found.');
            return;
        }

        try {
            const autoScrollExtension = window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll;
            const hasAutoScroll = typeof autoScrollExtension === 'function';
            let splide = new Splide(carousel, buildCarouselOptions(hasAutoScroll));

            if (hasAutoScroll) {
                splide.mount({ AutoScroll: autoScrollExtension });
            } else {
                splide.mount();
            }

            let autoScrollMounted = !!(splide.Components && splide.Components.AutoScroll);

            if (hasAutoScroll && !autoScrollMounted) {
                console.warn('CommunityInvolvement: AutoScroll extension detected but not mounted. Falling back to timed auto-advance.');
                splide.destroy(true);
                splide = new Splide(carousel, buildCarouselOptions(false));
                splide.mount();
                autoScrollMounted = false;
            }

            let manualAutoAdvanceTimer = null;
            if (!autoScrollMounted) {
                manualAutoAdvanceTimer = window.setInterval(function () {
                    if (!document.hidden) {
                        splide.go('>');
                    }
                }, 1000);

                // Wire up toggle button manually for fallback path
                const toggleBtn = carousel.querySelector('.splide__toggle');
                if (toggleBtn) {
                    let paused = false;
                    toggleBtn.addEventListener('click', function () {
                        paused = !paused;
                        carousel.classList.toggle('is-paused', paused);
                        toggleBtn.classList.toggle('is-active', !paused);
                        toggleBtn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
                        if (paused) {
                            clearInterval(manualAutoAdvanceTimer);
                            manualAutoAdvanceTimer = null;
                        } else {
                            manualAutoAdvanceTimer = window.setInterval(function () {
                                if (!document.hidden) { splide.go('>'); }
                            }, 1000);
                        }
                    });
                }
            } else {
                resumeSplideAutoplay(splide, true);
            }

            const handleResume = function () {
                if (!document.hidden) {
                    if (autoScrollMounted) {
                        resumeSplideAutoplay(splide, true);
                    }
                    // fallback path: timer is already running unless user paused it
                }
            };

            document.addEventListener('visibilitychange', handleResume);
            window.addEventListener('focus', handleResume);
            window.addEventListener('pageshow', handleResume);

            // Splide automatically handles play/pause toggle button functionality
            // when it finds elements with the proper classes in the DOM

        } catch (err) {
            console.error('CommunityInvolvement: error initializing Splide', err);
        }
    }

    return {
        init: init
    };

})();

document.addEventListener('DOMContentLoaded', function () {
    App.CommunityInvolvement.init();
});
